import {
  ADMISSION_STATUS_HIDDEN_BY_TRIGGER,
  ADMISSION_STATUS_IN_REVIEW,
} from '@components/admission-card/src/admission-card.type';
import { checkIsSiaeOfferInReview } from '@components/forms/utils/siae-status';
import { Admission } from '@domain/admission';
import { EventListItemSettings, EventSettings } from '@domain/event';
import { fromBackend } from '@utils/map-date/from-backend';
import moment from 'moment';

export const calculateOfferStatus = (
  admission: Admission,
  timezone: string,
  settings?: EventSettings | EventListItemSettings
) => {
  if (admission.salesTime.openingTime) {
    const startTime = fromBackend(admission.salesTime.openingTime, timezone).unix();
    const now = moment().tz(timezone).unix();
    const isSiaeOfferInReview = checkIsSiaeOfferInReview(admission, settings);
    if (isSiaeOfferInReview) return ADMISSION_STATUS_IN_REVIEW;
    if (startTime && startTime > now) {
      return ADMISSION_STATUS_HIDDEN_BY_TRIGGER;
    }
  }
  return admission.status;
};
